import { AnyDocument, Category, PartialDocument } from '../types';

export default (doc: AnyDocument | PartialDocument<AnyDocument, 'category' | 'overrides'>): Category => {
  if (doc.overrides && doc.overrides.category !== undefined) {
    return doc.overrides.category;
  }

  return doc.category;
};
